<template>
  <div class="zyc-class-table-screen">
    <div class="jssc-flgl-right-table-screen">
      <div class="jssc-flgl-right-table-screen-keyword">
        <el-select v-model="selVal" style="width: 160px; height: 34px; float: left;" placeholder="请选择排序" :popper-append-to-body="true" @change="selChange">
          <el-option v-for="i in list.sel" :value="i.value" :label="i.label" :key="i.value"></el-option>
        </el-select>
        <div style="width: 1px; height: 14px; background: #23CEFD; opacity: 0.39;float:left;margin-top:10px;"></div>
        <div class="jssc-flgl-right-table-screen-keyword-input">
          <template v-if="isSelInput">
            <el-input :placeholder="inputPlac"
                      clearable
                      style="width:210px;"
                      :ref="inputRef"
                      v-model="inputVal">
            </el-input>
          </template>
          <template v-if="isType">
            <el-checkbox-group v-model="typeVal">
              <el-checkbox v-for="i in list.type" :label="i.label" :value="i.value" :key="i.value"></el-checkbox>
            </el-checkbox-group>
          </template>
          <template v-if="isLawType">
            <el-checkbox-group v-model="lawTypeVal">
              <el-checkbox v-for="i in list.lawType" :label="i.label" :value="i.value" :key="i.value"></el-checkbox>
            </el-checkbox-group>
          </template>
          <template v-if="isDate">
            <el-date-picker v-model="dateVal"
                            type="daterange"
                            value-format="yyyy-MM-dd"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
            </el-date-picker>
          </template>
        </div>
        <div class="jssc-flgl-right-table-screen-keyword-but" @click="searchClick">
          <i class="el-icon-search"></i>
        </div>
      </div>
      <el-select v-model="sortType" style="width: 130px;height:34px;float:left;" placeholder="请选择排序" :popper-append-to-body="true" @change="handleSortChange">
        <el-option v-for="i in list.sort" :value="i.value" :label="i.label" :key="i.value"></el-option>
      </el-select>
      <div class="jssc-qyjz-list-content-table-searchOrSetup">
        <el-tooltip class="item" effect="dark" content="导出" placement="top" :popper-options="{ appendToBody: false }">
          <div class="jssc-qyjz-list-content-table-searchOrSetup-export" @click="handleExport"></div>
        </el-tooltip>
        <el-tooltip class="item" effect="dark" content="设置" placement="top" :popper-options="{ appendToBody: false }">
          <div class="jssc-qyjz-list-content-table-searchOrSetup-setup" @click="handleSetUp"></div>
        </el-tooltip>
      </div>
    </div>
  </div>
</template>

<script>
  import { getDicListByCode } from '@/plugins/api/other/public'
  export const sort = [
    {
      label: '按申请日倒序',
      value: 1
    },
    {
      label: '按申请日顺序',
      value: 2
    },
    {
      label: '按相关性排序',
      value: 3
    }
  ]
export default {
  name: "zycClassTableScreen",
  props: {
    screenClick: {
      type: Function,
      default: () => { }
    },
    exportClick: {
      type: Function,
      default: () => { }
    },
    setUpClick: {
      type: Function,
      default: () => { }
    },
    sortChange: {
      type: Function,
      default: () => { }
    },
    selectData: {
      type: Array,
      default: () => []
    }
  },
  model: {
  },
  watch: {
    selectData:{
      handler: function (newVal, oldVal) {
        this.list.sel = newVal
        console.log('this.list.sel',this.list.sel)
        if (newVal) {
          this.checkSelectReq('patent_name;application_number', 'keyword')
        }
      },
      immediate: true
    }
  },
  data() {
    return {
      inputRef: Math.random().toString(36).slice(2),
      inputPlac: '请输入专利名称查询',
      selVal: 'patent_name;application_number',
      inputVal: '',
      sortType: 3,
      dateVal: [],
      typeVal: [],
      lawTypeVal: [],
      isSelInput: true,
      isType: false,
      isDate: false,
      isLawType: false,
      list: {
        sel: [],
        sort: sort,
        type: [],
        lawType: []
      },
      req: {
        current: 1,
        size: 10,
        keyword: '',
        patentTypeArray: [],
        legalStatusArray: [],
        ipcArray: [],
        applicationDateRange: [],
        publicationDateRange: [],
        currentApplicantOrOwner: '',
        inventor: [],
        highValuePatentArray: [],
        keyIndustriesArray: [],
        sortType: '',
        categoryType: 1,
        categoryArray: []
      }
    }
  },
  mounted() {
  },
  created() {
    this.$nextTick(() => {
      this.initData()
    })
  },
  methods: {
    initData: function () {
      this.getTypeData()
      this.getLawTypeData()
    },
    getTypeData: function () {
      getDicListByCode(1).then(res => {
        this.list.type = res.data
      })
    },
    getLawTypeData: function () {
      getDicListByCode(2).then(res => {
        this.list.lawType = res.data
      })
    },
    selChange: function (val) {
      this.isType = false
      this.isDate = false
      this.isLawType = false
      this.isSelInput = true
      this.inputVal = ''
      this.dateVal = []
      this.typeVal = []
      switch (val) {
        case 'patent_name;application_number':
          this.inputPlac = '请输入专利名称/申请号查询'
          this.checkSelectReq('patent_name;application_number', 'keyword')
          break
        case 'patent_type':
          this.isSelInput = false
          this.isType = true
          this.checkSelectReq('patent_type', 'patentTypeArray')
          break
        case 'legal_status':
          this.isSelInput = false
          this.isLawType = true
          this.checkSelectReq('legal_status', 'legalStatusArray')
          break
        case 'application_date':
          this.isSelInput = false
          this.isDate = true
          this.checkSelectReq('application_date', 'applicationDateRange')
          break
        case 'publication_number':
          this.inputPlac = '请输入公开号查询'
          this.checkSelectReq('publication_number', 'keyword')
          break
        case 'abstracts':
          this.inputPlac = '请输入摘要查询'
          this.checkSelectReq('abstracts', 'keyword')
          break
        case 'claims':
          this.inputPlac = '请输入权利要求书查询'
          this.checkSelectReq('claims', 'keyword')
          break
        case 'publication_date':
          this.isSelInput = false
          this.isDate = true
          this.checkSelectReq('publication_date', 'publicationDateRange')
          break
        case 'ipc':
          this.inputPlac = '请输入分类号查询'
          this.checkSelectReq('ipc', 'keyword')
          break
        case 'inventor':
          this.inputPlac = '请输入发明(设计)人查询'
          this.checkSelectReq('inventor', 'inventor')
          break
        case 'current_applicant;current_owner':
          this.inputPlac = '请输入申请(专利权)人查询'
          this.checkSelectReq('current_applicant;current_owner', 'currentApplicantOrOwner')
          break
        case 'agency':
          this.inputPlac = '请输入专利代理机构查询'
          this.checkSelectReq('agency', 'keyword')
          break
        case 'agent':
          this.inputPlac = '请输入代理人查询'
          this.checkSelectReq('agent', 'keyword')
          break
        case 'applicant_address':
          this.inputPlac = '请输入地址查询'
          this.checkSelectReq('applicant_address','keyword')
          break
      }
    },
    handleSortChange: function () {
      // 排序变更执行
      this.sortChange(this.sortType)
    },
    checkSelectReq: function (type,val) {
      this.list.sel.forEach((el, i) => {
        if (el.value == type) {
          this.$set(el, 'req', val)
        }
      })
    },
    searchClick: function () {
      // 点击放大镜执行
      var value = this.inputVal
      var obj = null
      if (this.selVal === 'patent_type') {
        value = this.typeVal
      }
      if (this.selVal === 'legal_status') {
        value = this.lawTypeVal
      }
      if (this.selVal === 'application_date' || this.selVal === 'publication_date') {
        value = this.dateVal
      }
      this.list.sel.forEach((el, i) => {
        if (el.value === this.selVal) {
          obj = el
        }
      })
      // 返回参数 请求接口参数名，参数值，排序, Code
      this.screenClick(obj.req, value, this.sortType, obj.value)
    },
    handleExport: function (val) {
      this.exportClick()
    },
    handleSetUp: function () {
      this.setUpClick()
    },
    reload: function () {
      this.inputVal = ''
      this.sortType = 3
    }
  }
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/common/zyc/other/classTableScreen.vue